import React from 'react';
import PropTypes from 'prop-types';

import COIModal from './COIModal.jsx';
import { useCOI } from '../../../hooks/useCOI.js';
import {
  CM_PRIMARY_ID,
  SE_COMMITTEE_ID,
  cmSeLabel,
} from '../../../../utils/constants';

const COIManager = ({
  selectedCandidate,
  onCandidateSelect,
  userDetails,
  sectionalCommitteesWithCmse,
  setNotificationTitle,
  setNotificationMessage,
}) => {
  const {
    showCOIModal,
    coiType,
    coiDetail,
    coiValidationError,
    coiTypeOptions,
    handleCOITypeChange,
    handleCOITypeRemove,
    handleCOISave,
    handleCOICancel,
    setCOIDetail,
  } = useCOI(
    selectedCandidate,
    onCandidateSelect,
    setNotificationTitle,
    setNotificationMessage,
  );

  const isAdmin =
    userDetails?.roles?.includes('super-admin') ||
    userDetails?.roles?.includes('admin');
  const isSCChair = userDetails?.roles?.includes('committee-chair');
  const isSCMember = userDetails?.roles?.includes('committee-member');
  const isCouncilMember = userDetails?.roles?.includes('council-member');

  const showCOIFeatures = isSCChair || isSCMember || isCouncilMember || isAdmin;

  const getCurrentCommitteeName = () => {
    const committeeId = parseInt(selectedCandidate?.sectionalCommitteeId);

    if (committeeId === CM_PRIMARY_ID || committeeId === SE_COMMITTEE_ID) {
      return cmSeLabel;
    }

    const committee = sectionalCommitteesWithCmse.find(
      (item) => item.id === committeeId,
    );
    return committee?.attributes?.name || '';
  };

  if (!showCOIFeatures) {
    return null;
  }

  return (
    <COIModal
      show={showCOIModal}
      onHide={handleCOICancel}
      selectedCandidate={selectedCandidate?.name}
      coiType={coiType}
      coiDetail={coiDetail}
      coiValidationError={coiValidationError}
      coiTypeOptions={coiTypeOptions}
      onTypeChange={handleCOITypeChange}
      onTypeRemove={handleCOITypeRemove}
      onDetailChange={setCOIDetail}
      onSave={handleCOISave}
      committeeName={getCurrentCommitteeName()}
    />
  );
};

COIManager.propTypes = {
  selectedCandidate: PropTypes.shape({
    name: PropTypes.string,
    sectionalCommitteeId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  onCandidateSelect: PropTypes.func.isRequired,
  userDetails: PropTypes.object,
  sectionalCommitteesWithCmse: PropTypes.array,
  setNotificationTitle: PropTypes.func,
  setNotificationMessage: PropTypes.func,
};

export default COIManager;
